import { faPen } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Checkbox } from 'components/Form/Checkbox/Checkbox';
import { PetAvatar } from 'components/Pet/Avatar/PetAvatar';
import { PetTypeChip } from 'components/Pet/TypeChip/PetTypeChip';
import { Tag } from 'components/UI/Tag/Tag';
import React from 'react';
import { Pet } from 'types/Pet';

import classes from './PetOption.module.scss';

interface PetOptionProps {
    pet: Pet;
    checked?: boolean;
    hideCheckbox?: boolean;
    onEdit?: () => void;
    onChange?: (checked: boolean) => void;
}

export const PetOption: React.FC<PetOptionProps> = props => {
    const petDescription = React.useMemo(() => {
        const breedName = props.pet.breed?.name ?? 'Not Defined';
        const petSize = props.pet.size.name;

        return `${breedName} - ${petSize}`;
    }, [props.pet]);

    const expiredVaccinesCount = React.useMemo(() => {
        return props.pet.vaccines.filter(vaccine => vaccine.status === 'Expired').length;
    }, [props.pet]);

    const togglePetHandler = () => {
        props.onChange?.(!props.checked);
    };

    return (
        <div className={classes.root}>
            <div className={classes.checkboxIconContainer}>
                {!props.hideCheckbox && (
                    <Checkbox checked={props.checked} onChange={togglePetHandler} />
                )}

                <PetAvatar
                    image={props.pet.image?.src}
                    petType={props.pet.type}
                    onClick={togglePetHandler}
                />
            </div>

            <div className={classes.petInfoContainer}>
                <p className={classes.petName} onClick={togglePetHandler}>
                    {props.pet.name}

                    <PetTypeChip petType={props.pet.type} />
                </p>
                <p className={classes.petDescription}>{petDescription}</p>

                {expiredVaccinesCount > 0 && (
                    <Tag className={classes.expiredVaccinesTag}>
                        {expiredVaccinesCount} Vaccine{expiredVaccinesCount > 1 ? 's' : ''} Expired
                    </Tag>
                )}
            </div>

            <div className={classes.petActionsContainer}>
                <button type="button" className={classes.editButton} onClick={props.onEdit}>
                    <FontAwesomeIcon icon={faPen} />
                    <span>Edit</span>
                </button>
            </div>
        </div>
    );
};
